<template>
  <div class="doctor-main-view width-responsiveness--centralized">
    <div class="doctor-main-view__container">
      <subheader
        title="Médicos"
        :centralized="true"
        :back-button-visible="true"
        :path="'/dashboard'"
      >
        <div class="search-box-container">
          <input
            v-model="filterInput"
            class="search-box__input"
            placeholder="Pesquisar..."
          >
          <img
            class="search-box__icon"
            src="/static/images/icon-search-purple.svg"
          >
        </div>
        <button
          class="btn btn-primary btn-regular-size"
          @click="$router.push('doctor/new')"
        >
          <img src="/static/images/icon-plus.svg">
          Novo Médico
        </button>
      </subheader>

      <div class="doctor-main-view__container">
        <doctor-list :filter-input="filterInput" />
      </div>
    </div>
    <page-scroll-top />
  </div>
</template>

<script>
import DoctorList from './DoctorList'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'

export default {
  name: 'DoctorMainView',
  components: {
    subheader: SubHeader,
    'doctor-list': DoctorList,
    'page-scroll-top': PageScrollTop
  },
  data: () => {
    return {
      filterInput: ''
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/mixins";

.doctor-main-view {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 150px;

  .btn-primary {
    height: 38px;
    border-radius: 3px;
    padding: 0 18px;
    letter-spacing: 0.8px;
    font-family: Roboto;
    font-weight: 500;
  }

  &__container {
    width: 100%;
  }

  button {
    svg {
      height: 0.6em;
    }
  }

  .subheader__content__right-side {
    display: flex;
    align-items: center;

    .search-box {
      &-container {
        display: flex;
        background-color: white;
        border-radius: 3px;
        padding: 0.5em 0.3em 0.5em 1em;
        margin-right: 1em;
      }

      &__input {
        background-color: white;
        border: 0;
        font-family: "Roboto", sans-serif;
        font-weight: 400;
        color: #4a4a4a;
        min-width: 187px;
        min-height: 19px;

        &::placeholder {
          color: #7a7a7a;
        }

        &:focus {
          border: 0;
          outline: none;
        }
      }

      &__icon {
        svg {
          width: 0.7em;
          height: 0.7em;

          path {
            fill: #7f1a54;
          }
        }
      }
    }
  }
  .subheader_container {
    button {
      img {
        position: relative;
        top: -1px;
      }
    }
  }
}
</style>
